import { useConfiguration } from '@travel-frontend/core';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { clickEvent, loadEvent, pageLoadEvent, pageViewEvent, tooltipEvent } from '../../hooks/useTracking/events/index.js';
let didTrackPageLoad = false;
export const useTracking = () => {
  const dispatch = useDispatch();
  const portal = useConfiguration('portal');
  const trackPageLoad = useCallback(props => {
    dispatch(pageLoadEvent.action({
      ...props,
      portal
    }));
  }, [dispatch, portal]);
  const trackPageView = useCallback(props => {
    dispatch(pageViewEvent.action({
      ...props,
      portal
    }));
  }, [dispatch, portal]);
  const trackPageImpression = useCallback(props => {
    // The very first impression is considered a "pageLoad" and should only be tracked once *per session*.
    // Any on page navigation afterwards is a "pageView".
    if (didTrackPageLoad) {
      trackPageView(props);
    } else {
      trackPageLoad(props);
      didTrackPageLoad = true;
    }
  }, [trackPageLoad, trackPageView]);
  const trackClickEvent = useCallback((trackingId, params) => {
    dispatch(clickEvent.action({
      event_action: trackingId,
      ...params
    }));
  }, [dispatch]);
  const trackLoadEvent = useCallback((trackingId, params) => {
    dispatch(loadEvent.action({
      event_action: trackingId,
      ...params
    }));
  }, [dispatch]);
  const trackTooltipEvent = useCallback((trackingId, params) => {
    dispatch(tooltipEvent.action({
      event_action: trackingId,
      ...params
    }));
  }, [dispatch]);
  return {
    trackPageImpression,
    trackClickEvent,
    trackLoadEvent,
    trackTooltipEvent
  };
};